<template>
	<div class="flex flex-grow">
		<div class="md:gap-1 flex-grow items-baseline" v-if="!isLoading">
			<div class="flex space-x-4">
				<BaseInput
					:label="$t('company_name_and_business_form')"
					ref="BaseInput.company.name"
					:required="true"
					type="text"
					v-model="companyData.name"
				/>
			</div>
			<div class="flex space-x-4">
				<BaseInput
					class="w-1/2"
					:label="$t('last_name_company_owner')"
					ref="BaseInput.company.nachname"
					:required="true"
					type="text"
					v-model="companyData.ownerLastname"
				/>
				<BaseInput
					class="w-1/2"
					:label="$t('first_name_company_owner')"
					ref="BaseInput.company.vorname"
					:required="true"
					type="text"
					v-model="companyData.ownerFirstname"
				/>
			</div>
			<div class="flex space-x-4">
				<BaseInput class="w-1/2" :label="$t('street')" ref="BaseInput.company.street" :required="true" type="text" v-model="companyData.street" />
				<BaseInput
					class="w-1/2"
					:label="$t('house_number')"
					ref="BaseInput.company.housenr"
					:required="false"
					type="text"
					v-model="companyData.houseNumber"
				/>
			</div>
			<CityInput ref="CityInput" v-model="companyData.city" />
			<div class="flex space-x-4">
				<BaseInput
					class="w-1/2"
					:label="$t('email_address_for_login')"
					ref="BaseInput.company.email"
					validationtype="email"
					:required="true"
					type="email"
					v-model="companyData.email"
				/>
				<BaseInput
					v-if="!isUserAllowedInLevel2"
					class="w-1/2"
					:label="$t('station_phone_number')"
					ref="BaseInput.company.phone"
					:required="true"
					type="text"
					v-model="companyData.phoneNumber"
				/>
				<BaseInput
					v-if="isUserAllowedInLevel2"
					class="w-1/2 pr-2"
					:label="$t('mobile_number')"
					ref="BaseInput.company.mobileNumber"
					validationtype="phone"
					type="tel"
					:required="true"
					v-model="companyData.mobileNumber"
				/>
			</div>
			<!---
			entfernt auf anweisung
			<div v-if="isUserAllowedInLevel3">
				<BaseInput
					class="w-1/2 pr-2"
					:label="$t('fax_number')"
					ref="BaseInput.company.fax"
					validationtype="phone"
					:required="false"
					type="text"
					v-model="companyData.fax"
				/>
			</div>
			-->
		</div>
		<LoadingSpinner v-else />
	</div>
</template>

<script>
import CityInput from '@/components/forms/CityInput';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import Authentication from '@/mixins/Authentication';
import { CompanyApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import Validate from '@/mixins/Validate';

export default {
	mixins: [Validate, Authentication],
	components: { LoadingSpinner, BaseInput, CityInput },
	name: 'OnboardingCompanyDataForm',
	mounted() {
		this.fetchDefaultData();
	},
	data() {
		return {
			isLoading: false,
			companyData: {
				city: {},
			},
		};
	},
	methods: {
		fetchDefaultData() {
			this.isLoading = true;
			CompanyApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.companyIdGet(this.getUser.person?.company?.company_id || this.getUser.person?.company?.id)
				.then(response => {
					this.companyData.ownerLastname = response.data.ownerLastname;
					this.companyData.ownerFirstname = response.data.ownerFirstname;
					this.companyData.email = response.data.email;
					this.isLoading = false;
				})
				.catch(e => {
					console.log(e);
					this.isLoading = false;
				});
		},
		getData() {
			return this.companyData;
		},
	},
};
</script>
